import { render, staticRenderFns } from "./ContractFlightDetails.vue?vue&type=template&id=08deb45e&scoped=true&"
import script from "./ContractFlightDetails.vue?vue&type=script&lang=js&"
export * from "./ContractFlightDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractFlightDetails.vue?vue&type=style&index=0&id=08deb45e&prod&lang=scss&"
import style1 from "./ContractFlightDetails.vue?vue&type=style&index=1&id=08deb45e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08deb45e",
  null
  
)

export default component.exports